import Layout from "components/Layout";
import Home from "containers/Home";
import React from "react";

const HomePage = () => (
  <Layout>
    <Home />
  </Layout>
);

export default HomePage;
